import React, { useEffect, useMemo, useState } from "react";
import { useControl, useControlActionHistory } from "../../controlContext";
import { useSource } from "../../sourceContext";
import { REP_BLOCK, REP_SEC, SUB } from "../../../../shared/Data/typeDirs";
// import TreeItem from "@mui/lab/TreeItem";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
// import TreeView from "@mui/lab/TreeView";
import { Col, Row } from "react-bootstrap";
import {Button, Box} from '@mui/joy';
// import { dataSource } from "../../../../services/dataSource";
// import { useUserContext } from "../../../revised_components/contextProviders/userContext";
import { Lock } from "react-feather";
import useScrollPercentage from "../../../scripts/useScrollPercentage";
// import { useControlHeaderContext } from "../../controlWrapperContext";

function linkToBlock(elementId, behavior = 'smooth') {
  const element = document.getElementById(elementId)
  if (element) {
    var schemaBlock = element.closest('.g-0')?.parentElement;
    if (schemaBlock) {    
      schemaBlock.scrollIntoView({
        behavior: behavior,
        block: 'start',
        inline: 'nearest'
      })
    }
  }
}

export function ReportBodyWrapper({ settings, setSettings, objectMetadata, scrollRef }) {
  const controls = useControl()
  const actionHistory = useControlActionHistory()
  const source = useSource()
  const scrollState = useScrollPercentage(scrollRef)
  let [per] = useMemo(() => [scrollState[1], scrollState[2]], [scrollState]) //just ignore the stupidity
  const controlIds = useMemo(() => controls.map(itm => itm._id).join(',') + `,${per}`, [controls, per])

  const topBlock = useMemo(() => {
    console.log('per', per)
    let idArray = controlIds.split(',').slice(0, controlIds.split(',').length - 1)

    for (let i = 0; i < idArray.length; i++) {
      // const block = controls.find()
      let [isVisible] = isElementInViewPort(document.getElementById(idArray[i]))
      if (isVisible) {
        return idArray[i] 
      }
    }
    return idArray[0]
  }, [controlIds])
  
  // const { user } = useUserContext()


  



  useEffect(()=>{
    // console.log('ReportBodyWrapper useEffect[actionHistory] |', topBlock, actionHistory)
    if(!topBlock 
      || !actionHistory.length 
      || !['sort_blocks', 'add_blocks'].includes(actionHistory[0].type)
      || ( actionHistory[0].type === 'sort_blocks' && !actionHistory[0].blockId )) return
    console.log('odd state', actionHistory[0])
    let blockId = actionHistory[0].blockId || actionHistory[0].blocks[0]._id
    linkToBlock(blockId || topBlock)
  }, [actionHistory])

  // const lockBlock = useCallback(async (blockIdx)=>{
  //   let {_id: newBlockId, type: newBlockType}= controls[blockIdx]
  //   let {idx, type, _id:blockId} = settings.lockedBlock? settings.lockedBlock : {}
  //   if(blockId) await dataSource('remDb')[REP_V2].unlockReportBlock({_id:blockId, type: type || REP_BLOCK})

  //   let lockList = await dataSource('remDb')[REP_V2].getReportLockStatus({_id:objectMetadata._id})
  //   console.log('ReportHeaderWrapper | lockBlock lockList', lockList)
  //   let lockMap = {}
  //   for (let i=0; i<lockList.length; i++){ 
  //     lockMap[lockList[i]._id] = lockList[i].locked !== user._id? lockList[i].locked : false
  //   }

  //   if(lockMap[newBlockId]){
  //     setSettings({...settings, lockMap, lockedBlock:{}})
  //     return
  //   }

  //   await dataSource('remDb')[REP_V2].lockReportBlock({_id:newBlockId, type: newBlockType || REP_BLOCK, user:user._id})
  //   setSettings({...settings, lockMap, lockedBlock:{_id:newBlockId, type: newBlockType, idx:blockIdx}})

  // }, [controls, settings] )

  // useEffect(()=>{
  //   lockBlock(topBlock)
  // }, [topBlock])

  const nav = useMemo(() => generateNavArray(controls, source, settings.lockMap), [controls, source, settings.lockMap])
  const selected = useMemo(() => {
    if (topBlock === 'Top') return ['Top']
    console.log('looking in controls for report section', topBlock, controls)
    let reportSection = controls.length && controls.find(itm=>itm._id === topBlock)[REP_SEC]
    return reportSection ? [topBlock, reportSection] : [topBlock]

  }, [topBlock, controls])

  // console.log('rendering tree view', selected)
  return (
    <NewTreeView
      data={nav}
      selected={selected}
    />
  )
}

function NewTreeView({ data, selected }) {
  const [expandedIds, setExpandedIds] = useState(['root'])
  const [lastClicked, setLastClicked] = useState(() => {
    // Initialize with Top as the first lastClicked
    const topItem = data.find(item => item.label === 'Top') || data[0]
    return topItem || { label: 'Top', onLabelClick: () => {} }
  })

  useEffect(() => {
    setExpandedIds(data.map(itm => `${itm.nodeId}`))
  }, [data])

  const handleToggle = (nodeId) => {
    setExpandedIds(prev => 
      prev.includes(nodeId) 
        ? prev.filter(id => id !== nodeId)
        : [...prev, nodeId]
    )
  }

  return (
    <div className="con-man-wrapper report-nav-container">
 
      <Button variant="plain"
        size="sm"
        className="report-nav-return-button btn-custom-primary-plain"
        onClick={() => lastClicked.onLabelClick()} >
        {`← Return to: ${lastClicked.label || ''}`}
      </Button>
    
      <div className="custom-tree-view report-body-wrapper-nav">
        {data.map((navDatum, treeIdx) => (
          <CustomTreeItem
            key={treeIdx}
            {...navDatum}
            setLastClicked={setLastClicked}
            expandedIds={expandedIds}
            onToggle={handleToggle}
            selected={selected}
          />
        ))}
      </div>
    </div>
  )
}

function CustomTreeItem(props) {
  const { onLabelClick, nodeId, children, setLastClicked, label, locked, expandedIds, onToggle, selected } = props
  const isExpanded = expandedIds.includes(nodeId)
  const hasChildren = children && children.length > 0
  const isSelected = selected.includes(nodeId)

  return (
    <div className="custom-tree-item" style={{ marginBottom: '4px' }}>
      <Row className="g-0 report-body-wrapper-entry-row" style={{
        border: locked ? '2px solid red' :  !props.root ? '1px solid rgb(200, 200, 200)' : 'none',
        backgroundColor: isSelected ? '#d8e6e5' :  !props.root ? '#ffffff' : '',
      }}>
        <Col sm={11}>
          <div 
            className="custom-tree-item-content"
            onClick={() => {
              setLastClicked(props)
              onLabelClick()
            }}
            style={{ 
              cursor: 'pointer', 
              padding: '8px',
              display: 'flex',
              alignItems: 'center',
              minHeight: '40px'
            }}
          >
            {hasChildren && (
              <span 
                onClick={(e) => {
                  e.stopPropagation()
                  onToggle(nodeId)
                }}
                style={{ 
                  marginRight: '8px', 
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  color: '#666'
                }}
              >
                {isExpanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
              </span>
            )}
            <span className="report-body-wrapper-entry-text" style={{ fontWeight: isSelected ? '600' : '400' }}>{label}</span>
          </div>
        </Col>
        <Col style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {locked ? (<Lock color="red" size={18} />) : null}
        </Col>
      </Row>
      {hasChildren && isExpanded && (
        <div className="custom-tree-item-children" style={{ 
          marginLeft: '20px',
          borderLeft: '2px solid #e0e0e0',
          paddingLeft: '8px'
        }}>
          {children.map(childDatum => (
            <CustomTreeItem
              key={childDatum.nodeId}
              {...childDatum}
              setLastClicked={setLastClicked}
              expandedIds={expandedIds}
              onToggle={onToggle}
              selected={selected}
              root={true}
            />
          ))}
        </div>
      )}
    </div>
  )
}

function generateNavArray(controls, source, lockList) {
  // console.log('generating new nav array')
  let _nav = []
  for (let i = 0; i < controls.length; i++) {
    const block = controls[i]
    let categorization = {}
    if (block.type === REP_BLOCK) {
      for (let cat_type of [REP_SEC, SUB]) {
        categorization[cat_type] = source[cat_type].find(src_itm => src_itm._id === block[cat_type])
      }
      let sectionNavElement = _nav.find(navItem => navItem.nodeId === block[REP_SEC])
      let newNavElement = {
        nodeId: `${block._id}`,
        locked: lockList && lockList[block._id],
        label: categorization[SUB].getDisplayText(block.blockName),
        onLabelClick: (...args) => {
          console.log('block:', block.blockName, args)
          linkToBlock(block._id)
        }
      }
      if (!sectionNavElement) {
        sectionNavElement = {
          nodeId: block[REP_SEC],
          // locked:lockList && lockList[block._id],
          label: categorization[REP_SEC].getDisplayText(),
          onLabelClick: (...args) => {
            console.log('block:', block.blockName, args)
            linkToBlock(block._id)
          },
          children: []
        }
        _nav.push(sectionNavElement)
      }
      sectionNavElement.children.push(newNavElement)

    } else {
      _nav.push({
        nodeId: block._id,
        locked: lockList && lockList[block._id],
        label: block.title || 'Top',
        onLabelClick: () => linkToBlock(block._id)
      })
    }
  }

  return _nav
}




// percent X,Y are amount to return true if greater than
function isElementInViewPort(element, percentX, percentY) {
  if (!element) return [false]
  var tolerance = 0.01;   //needed because the rects returned by getBoundingClientRect provide the position up to 10 decimals
  if (percentX == null) {
    percentX = 40;
  }
  if (percentY == null) {
    percentY = 40;
  }

  var elementRect = element.parentElement.parentElement.getBoundingClientRect();
  var parentRect
  // var element = this;
  // console.log('start loop')
  parentRect = element.parentElement.parentElement.parentElement.parentElement.parentElement.getBoundingClientRect();
  // while (!element.className.includes('control-manager-child-container')) {
  //   element = element.parentElement;
  //   console.log('looping looking')
  // }
  // console.log('topmost parent?', parentRect, element, element.className)
  // var visibleInAllParents = parentRects.every(function(parentRect){
  // var visiblePixelX = Math.min(elementRect.right, parentRect.right) - Math.max(elementRect.left, parentRect.left);
  var visiblePixelY = Math.min(elementRect.bottom, parentRect.bottom) - Math.max(elementRect.top, parentRect.top);


  // var visiblePercentageX = visiblePixelX / parentRect.width * 100;
  var visiblePercentageY = visiblePixelY / parentRect.height * 100;
  // console.log('got these results', visiblePercentageY, visiblePixelY)
  return [visiblePercentageY + tolerance > percentY, visiblePercentageY];
  // });
  // return visibleInAllParents;
}